module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/15-d783b34df1aa236fff2d5ee6c1c0db49.jpg";